import React from "react";
import { BsChevronRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import { categories } from "../Data/Homepage";

export const FlowsFilter = ({ id, showBrowse }) => {
  return (
    <div
      className={
        showBrowse
          ? "py-4 px-4"
          : "flex lg:flex-col space-x-4 py-4 px-0 lg:space-x-0 overflow-x-scroll hidescroll"
      }
    >
      {categories.map((filter) => {
        const trimmedCategory = filter.category.trim();
        const isActive = trimmedCategory === id.trim();
        return (
          <Link
            key={filter.category} // Add a key to each element
            to={`/Pages/AllFlows/${trimmedCategory}`}
            className={
              isActive
                ? "bg-[#1C1C1C] shrink-0 w-fit rounded-xl dark:bg-white dark:text-black  dark:border px-4 py-2 md:px-4 md:py-[11px] text-white flex items-center justify-between my-2  md:min-w-96 lg:w-full "
                : "flex border  lg:border-none items-center justify-between my-2 px-4 py-2 md:px-4 md:py-[11px] lg:min-w-[300px] rounded-lg w-fit shrink-0 dark:border-[#5B5B5B]"
            }
          >
            <div className="flex items-center justify-between  space-x-2 shrink-0 w-full">
              <div className="flex items-center space-x-2">
                {/* <img
                alt=""
                src={filter.icon}
                className="text-2xl w-4 h-4 md:h-[18px] md:w-[18px] dark:text-[#C7C7C7]"
                /> */}
                <div className="">{filter.icon}</div>
                <p>{trimmedCategory}</p>
              </div>
              <BsChevronRight
                className={isActive ? "lg:block hidden" : "hidden"}
              />
            </div>
          </Link>
        );
      })}
    </div>
  );
};
